/**
 * RequirePermission — client-side permission gate for a module (ODE-P01-T10).
 *
 * Renders the REQ-090 `blocked` state when the session roles lack the
 * module's permission (UX mirror of the OD-015 catalog). This is NOT the
 * security boundary — the server-side T08 guard enforces authorization and
 * would return 403 regardless.
 *
 * Traces to: ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { hasPermission, type ModuleDefinition } from '../rbac/catalog.js';
import { StateView } from './StateView.js';

export function RequirePermission({
  module,
  children,
}: {
  readonly module: ModuleDefinition;
  readonly children: ReactNode;
}): JSX.Element {
  const { session } = useAuth();
  if (session === null) {
    return <Navigate to="/login" replace />;
  }
  if (!hasPermission(session.staff.roles, module.permission)) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: `Peran tidak memiliki izin ${module.permission} untuk modul ini.`,
        }}
      />
    );
  }
  return <>{children}</>;
}